import {CognitoUserPool} from 'amazon-cognito-identity-js'
import axios from 'axios'
import {connect} from 'react-redux'

// Redux
import {initialize, login} from 'app/state/modules/auth'
import store from 'app/state/store'

// Settings
import settings from 'settings'

// Utils
import {getEmailFromJWT, getUsernameFromJWT} from 'app/views/utils/auth'


export const api = ({
  method,
  url,
  idToken,
  data,
  cancelToken,
  params,
  headers = {},
  opts = {},
}) => new Promise((resolve, reject) => {
  axios({
    method,
    url,
    headers: idToken ? {
      Authorization: idToken,
      ...headers
    } : headers,
    data,
    params,
    cancelToken,
    ...opts,
  }).then((response) => {
    resolve(response)
  }).catch((error) => {
    if (!(axios.isCancel(error))) {
      console.error('error', error)
    }
    if (error.response !== undefined && error.response.status === 401) {
      const poolData = {
        UserPoolId: settings.cognito.authData.UserPoolId,
        ClientId: settings.cognito.authData.ClientId,
      }
      const userPool = new CognitoUserPool(poolData)
      const user = userPool.getCurrentUser()
      if (user !== null) {
        user.getSession((err, session) => {
          if (err) {
            console.error('Error with user.getSession(): ', err)
            reject(err)
          } else {
            user.refreshSession(session.refreshToken, (newError, newSession) => {
              if (newError) {
                console.error('error with refresh session: ', newError)
                reject(newError)
              } else {
                store.dispatch(
                  login(
                    getUsernameFromJWT(newSession.idToken.jwtToken),
                    getEmailFromJWT(newSession.idToken.jwtToken),
                    newSession.accessToken.jwtToken,
                    newSession.idToken.jwtToken,
                  ),
                )
                axios({
                  method,
                  url,
                  headers: {
                    Authorization: newSession.idToken.jwtToken,
                    ...headers
                  },
                  data,
                  params,
                  ...opts,
                }).then((secondTryResponse) => {
                  // eslint-disable-next-line no-console
                  console.log('The request was successful after refreshing the session.') // Allow users to check if a session was refreshed
                  resolve(secondTryResponse)
                }).catch((secondTryError) => {
                  console.error('An error occurred after refreshing the session.')
                  reject(secondTryError)
                })
              }
            })
          }
        })
      }
    } else {
      reject(error)
    }
  })
})

const mapStateToProps = () => ({})
const mapDispatchToProps = dispatch => ({
  onInitialize: (loggedIn, unauthenticatedId) => {
    dispatch(initialize(loggedIn, unauthenticatedId))
  },
  onLogin: (username, email, accessToken, idToken) => {
    dispatch(login(username, email, accessToken, idToken))
  },
})
export default connect(mapStateToProps, mapDispatchToProps)(api)
